/**
 * Account Helper
 */

const getFullName = (account) => `${account.givenName || ''} ${account.familyName || ''}`.trim();
const getFamilyName = (account) => `${account.familyName || ''}`.trim();
const sortListByFamilyName = (a, b) => (getFamilyName(a).localeCompare(getFamilyName(b)));

export default {
  getFullName,
  getFamilyName,
  sortListByFamilyName,
};
